import { Stack } from '@mui/material';
import { ConductType } from '@schooly/api';
import { TypographyWithOverflowHint } from '@schooly/style';
import React, { FC } from 'react';

import { ConductConnotationIndicator } from '../ConductGrid';

export const ConductTypeOption: FC<Pick<ConductType, 'connotation' | 'name'>> = ({
  name,
  connotation,
}) => (
  <Stack direction="row" alignItems="center" gap={1} width="100%">
    <ConductConnotationIndicator connotation={connotation} />
    <TypographyWithOverflowHint variant="h3">{name}</TypographyWithOverflowHint>
  </Stack>
);
